// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '27.51px',
  color: '#e7eef4',
}

const propTypes = {
  width: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconBell({ width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.51 33.512"
      width={width}
    >
      <g transform="translate(-2.956 -21.083)">
        <g transform="translate(3.206 21.333)">
          <path
            fill={color}
            stroke={color}
            strokeWidth="0.5px"
            d="M88.009,37.089V34.838a10.519,10.519,0,0,0-7.5-10.061v-.442a3,3,0,1,0-6,0v.442A10.519,10.519,0,0,0,67,34.838v2.251c0,4.995-1.175,6.75-2.034,8.031A4.248,4.248,0,0,0,64,47.593c0,2.446,5.1,3.3,9.233,3.6a4.47,4.47,0,0,0,8.543,0c4.134-.3,9.233-1.154,9.233-3.6a4.247,4.247,0,0,0-.967-2.473C89.184,43.838,88.009,42.084,88.009,37.089ZM76,24.334a1.5,1.5,0,0,1,3,0v.12a9.453,9.453,0,0,0-3,0Zm1.5,29.514c-1.121,0-2.728-1.565-3.239-2.5,1.063.045,2.607,0,3.239,0s2.235.045,3.3,0C80.292,52.283,78.626,53.848,77.5,53.848Zm0-4c-6.871,0-12-1.188-12-2.251a2.856,2.856,0,0,1,.714-1.638c.91-1.36,2.287-3.415,2.287-8.866V34.838a9,9,0,0,1,18.007,0v2.251c0,5.451,1.377,7.506,2.287,8.866a2.856,2.856,0,0,1,.714,1.638C89.509,48.655,84.376,49.843,77.5,49.843Z"
            transform="translate(-64 -21.333)"
          />
        </g>
      </g>
    </svg>
  )
}

IconBell.defaultProps = defaultProps
IconBell.propTypes = propTypes

export default IconBell
